<template>
    <el-dialog append-to-body :visible="isShow" @close="hide" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="form" :model="form" label-width="90px" size="mini">
            <el-form-item label="扩展名称">
                <el-input size="mini"  v-model="form.extensionName"></el-input>
            </el-form-item>
            <el-form-item label="系统简称">
                <el-input size="mini"  v-model="form.systemCode"></el-input>
            </el-form-item>
            <el-form-item label="扩展类型">
                <el-radio-group v-model="form.type" size="medium">
                    <el-radio label="ALL">全局</el-radio>
                    <el-radio label="ROLE">类别</el-radio>
                    <el-radio label="ACCOUNT">个体</el-radio>
                    <el-radio label="AUTO">自定义</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="分配值" v-show="form.type!=='ALL'">
                <el-input size="mini"  v-model="form.typeValue" placeholder="如果类型是个体，这里填用户唯一值，如果这是类别，就填写类别唯一值"></el-input>
            </el-form-item>
            <el-form-item label="扩展内容">
                <el-input type="textarea" size="mini"  v-model="form.content"></el-input>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="hide">取 消</el-button>
            <el-button size="mini" type="primary" @click="save">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        props:{
            data:Object
        },
        data() {
            return {
                form:{...this.data},
                isShow:true
            }
        },
        methods: {
            hide(){
                this.$emit("hide");
            },
            save(){
                const errorTxt=this.check();
                if(errorTxt){
                    this.$alert(errorTxt);
                    return;
                }
                this.$emit("hide");
                this.$emit("save",this.form);
            },
            check(){
                const form=this.form;
                if(!form.extensionName)return "名称必填！";
                if(!form.systemCode)return "系统简称必填！";
                if(!form.type)return "扩展类型必选！";
                if(!form.typeValue)return "分配值必填！";
                if(!form.content)return "扩展内容必填！";
                return null
            }
        },
        mounted(){

        }
    }
</script>
